import 'angular';
import Features from '../feature-manager/Features';
var Netmask = require('netmask').Netmask;
import {Constants} from '@amzn/aws-workdocs-web-client-common';

function IpWhitelistingCtrl($scope, $translate, $log, $uibModal, $rootScope, AccessControlService, MessageManager, ClientMetricsService, FeatureManagerService) {

    $scope.ipwhitelistingState = {
        cidrEntry: null,
        isCidrListUpdated: false,
        cidrList: [],
        temporaryCidrList: [],
        policyLoaded: false,
        currentIpAddress: null,
        ipWhitelistingConfirmationCheckbox: false,
        ipWhitelistingConfirmationText: "",
    }

    const METRICS_EVENTS = {
        IP_WHITELISTING_UPDATE_SUCCESS: {name: 'IP_Whitelisting_Update_Successful'},
        IP_WHITELISTING_UPDATE_FAILED: {name: 'IP_Whitelisting_Update_Successful'},
        IP_WHITELISTING_CONFIRMATION_POPUP_SHOWN: {name: 'IP_Whitelisting_Confirmation_Popup_shown'}
    };

    if (FeatureManagerService.isFeatureEnabled(Features.UI.IP_WHITELISTING)) {
        var describeLatencyEvent = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();

        AccessControlService.describeOrganizationAccessControlPolicy().then(function (response) {
            $log.info("Access Control Policy Retrieved Successfully");
            $scope.ipwhitelistingState.cidrList = response.data.AccessControlPolicy.AllowedCIDRList || [];
            $scope.ipwhitelistingState.temporaryCidrList = angular.copy($scope.ipwhitelistingState.cidrList) || [];
            $scope.ipwhitelistingState.isCidrListUpdated = false;
            $scope.ipwhitelistingState.currentIpAddress = response.data.SourceIpAddress;
            $scope.ipwhitelistingState.policyLoaded = true;
            describeLatencyEvent.emitMetricWithMethodName("IP_Whitelisting.Describe_Success_Latency");
        }, function (error) {
            $scope.ipwhitelistingState.policyLoaded = false;
            $log.error("Error Retrieving data");
            MessageManager.addErrorMessage($translate.instant('IP_WHITELISTING.ERRORS.UNABLE_TO_LOAD'));
            describeLatencyEvent.emitMetricWithMethodName("IP_Whitelisting.Describe_Success_Latency");
            $scope.$close(true);
        });
    }

    

    $scope.addCidrEntry = function () {
        MessageManager.resetAllMessages();

        // You can view the strings that match this regex in this link https://regex101.com/r/J8m8bl/1
        var cidrRegex = Constants.CidrRegularExpression;
        if (!$scope.ipwhitelistingState.cidrEntry.match(cidrRegex)) {
            MessageManager.addErrorMessage($translate.instant('IP_WHITELISTING.ERRORS.INVALID_CIDR'));
            $scope.ipwhitelistingState.cidrEntry = "";
            return;
        }

        if ($scope.ipwhitelistingState.temporaryCidrList.length >= 500) {
            MessageManager.addErrorMessage($translate.instant('IP_WHITELISTING.ERRORS.CIDR_LIMIT_REACHED'));
            $scope.ipwhitelistingState.cidrEntry = "";
            return;
        }

        if ($scope.ipwhitelistingState.temporaryCidrList.indexOf($scope.ipwhitelistingState.cidrEntry) === -1) {
            $scope.ipwhitelistingState.temporaryCidrList.push($scope.ipwhitelistingState.cidrEntry);
        } else {
            MessageManager.addErrorMessage($translate.instant('IP_WHITELISTING.ERRORS.DUPLICATE_ENTRY'));
        }

        $scope.ipwhitelistingState.cidrEntry = "";

        if ($scope.ipwhitelistingState.cidrList && $scope.ipwhitelistingState.temporaryCidrList &&
            $scope.ipwhitelistingState.cidrList.length > 0 && $scope.ipwhitelistingState.temporaryCidrList.length > 0 &&
            angular.equals($scope.ipwhitelistingState.temporaryCidrList.sort(), $scope.ipwhitelistingState.cidrList.sort())) {
            $scope.ipwhitelistingState.isCidrListUpdated = false;
        } else {
            $scope.ipwhitelistingState.isCidrListUpdated = true;
        }
    };

    $scope.removeCidrEntry = function (value) {
        MessageManager.resetAllMessages();

        var oldList = $scope.ipwhitelistingState.temporaryCidrList;
        $scope.ipwhitelistingState.temporaryCidrList = [];

        angular.forEach(oldList, function (element) {
            if (element != value) {
                $scope.ipwhitelistingState.temporaryCidrList.push(element);
            }
        });

        if ($scope.ipwhitelistingState.cidrList && $scope.ipwhitelistingState.temporaryCidrList &&
            $scope.ipwhitelistingState.cidrList.length > 0 && $scope.ipwhitelistingState.temporaryCidrList.length > 0 &&
            angular.equals($scope.ipwhitelistingState.temporaryCidrList.sort(), $scope.ipwhitelistingState.cidrList.sort())) {
            $scope.ipwhitelistingState.isCidrListUpdated = false;
        } else {
            $scope.ipwhitelistingState.isCidrListUpdated = true;
        }
    };

    $scope.updateCidrButtonClicked = function () {
        if ($scope.isUpdateButtonDisabled()) {
            $log.info("Update button is disabled. Not doing any action");
            return;
        }

        $scope.updateCIDRList();
    };

    $scope.updateCIDRList = function () {
        var updateLatencyEvent = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();
        
        $log.info("Updating the CIDR Entries");
        
        AccessControlService.updateOrganizationAccessControlPolicy($scope.ipwhitelistingState.temporaryCidrList).then(function (response) {
            $log.info("Successfully Updated the CIDR Entries");
            MessageManager.addSuccessMessage($translate.instant('IP_WHITELISTING.SUCCESS.UPDATE_SUCCESSFUL'));
            $scope.ipwhitelistingState.cidrList = response.data.AccessControlPolicy.AllowedCIDRList;
            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.IP_WHITELISTING_UPDATE_SUCCESS, 1);
            updateLatencyEvent.emitMetricWithMethodName("IP_Whitelisting.Update_Success_Latency");
        },
        function (error) {
            $log.error(error);
            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.IP_WHITELISTING_UPDATE_FAILED, 1);
            updateLatencyEvent.emitMetricWithMethodName("IP_Whitelisting.Update_Failed_Latency");
            MessageManager.addErrorMessage($translate.instant('IP_WHITELISTING.ERRORS.UPDATE_FAILED'));
        });
        $scope.$close(true);    

    };

    $scope.showWarningSection = function() {
        var currentIpAddressInCIDRList = false;

        for (var i = 0; i < $scope.ipwhitelistingState.temporaryCidrList.length; i++) {
            var block = new Netmask($scope.ipwhitelistingState.temporaryCidrList[i]);
            if (block.contains($scope.ipwhitelistingState.currentIpAddress)) {
                currentIpAddressInCIDRList = true;
                break;
            }
        }

        return $scope.ipwhitelistingState.temporaryCidrList.length > 0 && !currentIpAddressInCIDRList;
    }

    $scope.isUpdateButtonDisabled = function() {
        if(!$scope.ipwhitelistingState.isCidrListUpdated) {
            return true;
        }
        return $scope.showWarningSection() && $scope.isIpWhitelistingConfirmationConditionsNotMet();

    }

    $scope.isIpWhitelistingConfirmationConditionsNotMet = function () {
        return !$scope.ipwhitelistingState.ipWhitelistingConfirmationCheckbox || $scope.ipwhitelistingState.ipWhitelistingConfirmationText != $scope.ipwhitelistingState.currentIpAddress;
    }

}

IpWhitelistingCtrl.$inject = ['$scope', '$translate', '$log','$uibModal', '$rootScope', 'AccessControlService', 'MessageManager', 'ClientMetricsService', 'FeatureManagerService'];

angular.module('GorillaBoy.services')
    .controller('IpWhitelistingCtrl', IpWhitelistingCtrl);
